import axios from "axios";

const instance = axios.create({
  baseURL: "https://tiktok-backend-michael.herokuapp.com/",
});

export default instance;
